/**
 * Removes one query parameter from the current URL without triggering an App
 * Router navigation. Other query parameters and the URL fragment are preserved.
 */
export const stripCurrentQueryParam = (name: string): void => {
  const url = new URL(globalThis.location.href);
  url.searchParams.delete(name);
  globalThis.history.replaceState(
    null,
    '',
    `${url.pathname}${url.search}${url.hash}`,
  );
};
